export default __webpack_public_path__ + "static/media/dropdown-arrow.a4957168.svg";